var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.33341V8.66675H14.6666V7.33341H11.9999ZM10.6666 11.7401C11.3066 12.2134 12.1399 12.8401 12.7999 13.3334C13.0666 12.9801 13.3333 12.6201 13.5999 12.2667C12.9399 11.7734 12.1066 11.1467 11.4666 10.6667C11.1999 11.0267 10.9333 11.3867 10.6666 11.7401ZM13.5999 3.73341C13.3333 3.38008 13.0666 3.02008 12.7999 2.66675C12.1399 3.16008 11.3066 3.78675 10.6666 4.26675C10.9333 4.62008 11.1999 4.98008 11.4666 5.33341C12.1066 4.85341 12.9399 4.23341 13.5999 3.73341ZM2.66659 6.00008C1.93325 6.00008 1.33325 6.60008 1.33325 7.33341V8.66675C1.33325 9.40008 1.93325 10.0001 2.66659 10.0001H3.33325V12.6667H4.66659V10.0001H5.33325L8.66659 12.0001V4.00008L5.33325 6.00008H2.66659ZM10.3333 8.00008C10.3333 7.11341 9.94659 6.31341 9.33325 5.76675V10.2267C9.94659 9.68675 10.3333 8.88675 10.3333 8.00008Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.af1bc540.svg";
export { ForwardRef as ReactComponent };